module.exports = __webpack_public_path__ + "static/media/pl.96b0ae5c.jpg";